import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="animate-spin rounded-full h-10 w-10 m-6 border-t-4 border-b-4 border-thirdgray"></div>
    </div>
  );
};

export default LoadingSpinner;
